import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';
import { Asignacion } from '../models/asignacion';

@Injectable()
export class AsignacionService {

  private asignacionEndpoint = environment.asignacionEndPoint;

  constructor(private http: HttpClient) { }

  // Se busca asignacion activa de una direccion IP
  public async asignacionActivaDeDireccionAsync(idDireccion: number): Promise<Asignacion> {
    return this.http.get(this.asignacionEndpoint + 'por/idDireccionIp/' + idDireccion).toPromise().then(
      res => res as Asignacion
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/asignacion.service.ts